webpackJsonp([35783957827783],{

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.IndexPage = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(62);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TitleAndMetaTags = __webpack_require__(69);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _socials = __webpack_require__(149);
	
	var _socials2 = _interopRequireDefault(_socials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// Home page of portfolio site
	//
	var IndexPage = exports.IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  // const homepage = data.wordpressPage
	  var profileImage = "https://avatars1.githubusercontent.com/u/11691740?s=400&u=afdc25daf8ef2da5a544a15ee74ce275f649b4fe&v=4";
	  // "https://media.licdn.com/mpr/mpr/shrinknp_400_400/AAMAAwDGAAwAAQAAAAAAAAoEAAAAJDA0MDM1NTMyLTc4NTAtNDI3ZS05NzE2LWZkNzQ1YWQzMTQ2ZA.jpg";
	  // "https://avatars2.githubusercontent.com/u/11691740?s=400&u=ecc0f3a8d8f7c26cd8fd8ad840eb249c4f1fccee&v=4";
	  // "https://scontent-sin6-1.xx.fbcdn.net/v/t31.0-8/13217611_10154542797444123_3236936950005546321_o.jpg?oh=dba792df2faf897da8ac69b3980562b6&oe=5AB904EE";
	  // "https://media.licdn.com/mpr/mpr/shrinknp_400_400/AAMAAwDGAAwAAQAAAAAAAA4jAAAAJGUzMzY3YWNkLTVhODQtNGQ4MC05OGU3LTcyNzcxYmI0YWZiMQ.jpg";
	  return Glamor.createElement(
	    "div",
	    { className: "front-page" },
	    Glamor.createElement(_TitleAndMetaTags2.default, { title: "Aaron Ong - Full Stack Developer" }),
	    Glamor.createElement(
	      "div",
	      { className: "card-wrap" },
	      Glamor.createElement(
	        "div",
	        { className: "image-wrap" },
	        Glamor.createElement(
	          "div",
	          { className: "mask" },
	          Glamor.createElement(
	            "div",
	            {
	              className: "profile-image",
	              style: {
	                backgroundImage: "url(" + profileImage + ")",
	                width: "213px",
	                height: "213px",
	                position: "relative",
	                left: "27px",
	                top: "-18px"
	              }
	            },
	            " "
	          )
	        )
	      ),
	      Glamor.createElement(
	        "div",
	        { className: "content" },
	        Glamor.createElement(
	          "h2",
	          null,
	          "Aaron Ong"
	        ),
	        Glamor.createElement(
	          "h3",
	          null,
	          "Full Stack Developer"
	        ),
	        Glamor.createElement(
	          "p",
	          null,
	          "Web Developer passionate about Software Design, and System Architecture. Also a Freelance Consultant, Basketball player and Liberal arts student."
	        ),
	        Glamor.createElement(_socials2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ef3f202f9ec217bfd70d.js